import React, {createContext, useEffect, useReducer, useContext} from "react";
import { LiferayService } from "../../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";

export const ReconversionEnergeticaControllerContext = createContext();

export const ACTIONS = {
    SET_DATA_TABLE: "SET_DATA_TABLE",
};

const initialState = {
    dataTable: null,
};

const ReconversionEnergeticaControllerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_DATA_TABLE: {
            return {
                ...state,
                dataTable: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

const ReconversionEnergeticaControllerContextProvider = ({ children }) => {
    const properties = useContext(ApplicationPropertiesContext);

    const [state, dispatch] = useReducer( ReconversionEnergeticaControllerReducer, initialState );

    useEffect(() => {
        LiferayService.getAllSolicitudesRES(properties.base_url_api).then(
            (response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_DATA_TABLE
                });
            }
        );
    }, []);

    return(
        <ReconversionEnergeticaControllerContext.Provider value={[state, dispatch]}>
            {children}
        </ReconversionEnergeticaControllerContext.Provider>
    );
};

export default ReconversionEnergeticaControllerContextProvider;